import { ListItemIcon, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled('div')({
  width: '100%',
});

export const SelectLabel = styled(Typography)({
  color: palette.text.header,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '128%',
  margin: '0 0 8px 0',
}) as typeof Typography;

export const AutocompleteOption = styled('li', {
  shouldForwardProp: (prop) => {
    return prop !== 'isSelected';
  },
})<{ isSelected: boolean }>(({ isSelected }) => {
  return {
    width: '100%',
    color: palette.text.header,
    fontSize: '14px',
    fontWeight: isSelected ? 500 : 400,
    lineHeight: '136%',
    padding: '8px !important',
    borderRadius: '8px',
    display: 'flex !important',
    justifyContent: 'space-between !important',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'transparent !important',

    '&.Mui-focused, &:hover': {
      backgroundColor: '#F4E8FF !important',
    },

    '&.MuiAutocomplete-option[aria-disabled="true"]': {
      opacity: '0.3 !important',
      backgroundColor: '#CCCCCC !important',
    },
  };
});

export const OptionLabel = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flex: 1,
});

export const OptionEnd = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  flexShrink: 0,
});

export const Checkmark = styled(ListItemIcon)({
  minWidth: 'auto !important',
  color: '#3D1E66',

  '> svg': {
    width: '20px',
    height: '20px',
  },
});
